import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NumberedListItem } from 'base-ui'

import { erxBonusLandingPageTextAccent } from '../../../../components/ErxBonusLandingPageTranslationValues'

export const ErxBonusLandingPageHowBonusIsCalculatedInfoV1: FC = () => {
  return (
    <div className="flex flex-1 flex-col gap-6">
      <div className="flex flex-col gap-4">
        <p className="text-m">
          <FormattedMessage id="deErx.bonus.howBonusIsCalculated.how.description" />
        </p>
      </div>

      <div className="hidden flex-col gap-4 tablet:flex">
        <p className="text-l font-medium">
          <FormattedMessage id="deErx.bonus.howBonusIsCalculated.process.title" />
        </p>

        <ol className="flex flex-col gap-6">
          <NumberedListItem>
            <FormattedMessage id="deErx.bonus.howBonusIsCalculated.process.redeem" />
          </NumberedListItem>
          <NumberedListItem>
            <FormattedMessage id="deErx.bonus.howBonusIsCalculated.process.receive" />
          </NumberedListItem>
          <NumberedListItem>
            <FormattedMessage
              id="deErx.bonus.howBonusIsCalculated.process.deduct"
              values={{
                accentuate: erxBonusLandingPageTextAccent,
              }}
            />
          </NumberedListItem>
        </ol>
      </div>
    </div>
  )
}
